import { render, staticRenderFns } from "./ShareView.vue?vue&type=template&id=33a9b230&scoped=true&"
import script from "./ShareView.vue?vue&type=script&lang=js&"
export * from "./ShareView.vue?vue&type=script&lang=js&"
import style0 from "./ShareView.vue?vue&type=style&index=0&id=33a9b230&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a9b230",
  null
  
)

export default component.exports